import { useRefetchQuery } from "libs/reactQuery";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect, useState } from "react";

import { AvailableToBePaidEarningsCountEventData } from "../siteBarCounters.types";

export const useEarningsCounter = () => {
  const { earningsSocket } = useContext(SocketsContext);

  const [earningsCount, setEarningsCount] = useState<number>(0);

  const refetchEarnings = useRefetchQuery(["earnings"]);

  useEffect(() => {
    if (earningsSocket.socket) {
      earningsSocket.socket?.on(
        "available-to-be-paid-earnings-count",
        (data: AvailableToBePaidEarningsCountEventData) => {
          if (data.totalCount) {
            setEarningsCount(data.totalCount);
            refetchEarnings();
          }
        }
      );
    }

    return () => {
      earningsSocket?.socket?.off("available-to-be-paid-earnings-count");
    };
  }, [earningsSocket.socket]);

  return { earningsCount };
};
